"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const classnames_1 = __importDefault(require("classnames"));
const react_tooltip_1 = __importDefault(require("react-tooltip"));
const fa_1 = require("react-icons/fa");
const uuidv4_1 = require("uuidv4");
const styles_1 = require("./styles");
exports.Label = ({ value, name, required, labelPosition = "left", size, className, tooltip, tooltipColor = '#000', labelAlign = "right", }) => {
    const id = uuidv4_1.uuid();
    const cima = labelPosition === "up";
    const labelClasses = classnames_1.default({ "col-sm-2": !size && !cima }, { [`col-lg-${size}`]: size && !cima }, { "col-form-label": !cima }, { "text-lg-right": !cima && labelAlign !== 'left' }, { "text-left": labelAlign === 'left' }, "font-weight-bold", className);
    return (react_1.default.createElement("label", { className: labelClasses, htmlFor: name },
        required && react_1.default.createElement("span", { className: "text-danger" }, "* "),
        tooltip && (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement(styles_1.Tooltip, { color: tooltipColor, "data-tip": true, "data-for": id },
                react_1.default.createElement(fa_1.FaQuestionCircle, null)),
            react_1.default.createElement(react_tooltip_1.default, { place: "top", type: "dark", effect: "solid", id: id }, tooltip))),
        value,
        ":"));
};
